/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BlockStatusViewModel
 */
export interface BlockStatusViewModel {
    /**
     * 
     * @type {boolean}
     * @memberof BlockStatusViewModel
     */
    isBlocked?: boolean;
}

export function BlockStatusViewModelFromJSON(json: any): BlockStatusViewModel {
    return BlockStatusViewModelFromJSONTyped(json, false);
}

export function BlockStatusViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlockStatusViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isBlocked': !exists(json, 'isBlocked') ? undefined : json['isBlocked'],
    };
}

export function BlockStatusViewModelToJSON(value?: BlockStatusViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isBlocked': value.isBlocked,
    };
}

